import { SetFlinksCredentialsRequest } from 'vopay';
import { useState } from 'react';
import { api } from '@/services/api.config';

export default function useSetFlinksCredentials() {
  const [saving, setSaving] = useState(false);

  async function setFlinksCredentials(request: SetFlinksCredentialsRequest) {
    try {
      setSaving(true);
      const res = await api.postSetFlinksCredentials(request);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSaving(false);
    }
  }

  return { saving, setFlinksCredentials };
}
